var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "绑定商品列表-" + (_vm.initDetail.channelName || ""),
        size: "80%",
        direction: "rtl",
        visible: _vm.visibleDrawer,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDrawer = $event
        },
        close: _vm.closeDrawer,
      },
    },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small", "label-width": "90px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "分类" } },
                    [
                      _c("el-cascader", {
                        staticClass: "selWidth ",
                        attrs: {
                          options: _vm.merCateList,
                          props: _vm.props,
                          clearable: "",
                          placeholder: "请选择",
                          size: "small",
                        },
                        on: { change: _vm.handerSearch },
                        model: {
                          value: _vm.listPram.cateId,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "cateId", $$v)
                          },
                          expression: "listPram.cateId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品品牌" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth ",
                          attrs: {
                            clearable: "",
                            placeholder: "请选择",
                            filterable: "",
                            "filter-method": _vm.handleAgreementSearch,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handerSearch("brand")
                            },
                          },
                          model: {
                            value: _vm.listPram.brandId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "brandId", $$v)
                            },
                            expression: "listPram.brandId",
                          },
                        },
                        _vm._l(_vm.brandOption, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.brandStr, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "名称" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth ",
                          attrs: {
                            placeholder: "名称",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "name", $$v)
                            },
                            expression: "listPram.name",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "SKU编码" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "SKU编码",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "skuCode", $$v)
                            },
                            expression: "listPram.skuCode",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex-btn" }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "mr10",
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.addProducts },
                      },
                      [_vm._v("添加绑定")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "mr10",
                        attrs: {
                          size: "small",
                          type: "danger",
                          disabled:
                            !_vm.selectIds ||
                            !_vm.selectIds.length ||
                            _vm.bindDetials.type != 3,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batchRemove(_vm.selectIds)
                          },
                        },
                      },
                      [_vm._v("批量移除")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { color: "red" } }, [
                      _vm._v(
                        _vm._s(
                          "注意：移除操作仅绑定方式为指定SKU可使用！当前绑定方式为：" +
                            (_vm.bindDetials && _vm.bindDetials.type
                              ? { 1: "指定分类", 2: "指定标签", 3: "指定SKU" }[
                                  _vm.bindDetials.type
                                ]
                              : "--")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuId", label: "ID", "min-width": "150" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuCode",
                  label: "SKU编码",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuName",
                  label: "SKU名称",
                  "min-width": "280",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cateName",
                  label: "商品分类",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "品牌", "min-width": "120" },
              }),
              _vm._v(" "),
              _vm.bindDetials.type == 3
                ? _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      "min-width": "180",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "mr10",
                                  attrs: { size: "small", type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.batchRemove([scope.row.skuId])
                                    },
                                  },
                                },
                                [_vm._v("移除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1964616558
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("BindChannel", {
        ref: "BindChannelRef",
        attrs: { miniProgramCustomer: _vm.miniProgramCustomer },
        on: { doRefresh: _vm.handerSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }